var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackedSquaresIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160714",
    "data-name": "Group 160714",
    transform: "translate(-279 -136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1961",
    "data-name": "Rectangle 1961",
    transform: "translate(282 139)",
    fill: "#fff",
    stroke: "#a6a8bb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 12,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1962",
    "data-name": "Rectangle 1962",
    transform: "translate(279 136)",
    fill: "#fff",
    stroke: "#a6a8bb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 12,
    rx: 3.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedSquaresIcon);
export default __webpack_public_path__ + "static/media/stacked-squares-icon.f0529bd4828d5973eb820de32ef4ecbb.svg";
export { ForwardRef as ReactComponent };